export enum OwnerTypesEnum {
  BUILDING = 'building',
  COMPANY = 'company',
  PORTFOLIO = 'portfolio',
  USER = 'user',
}
